import { render, staticRenderFns } from "./RegistPower.vue?vue&type=template&id=2d5d53ae&scoped=true&"
import script from "./RegistPower.vue?vue&type=script&lang=js&"
export * from "./RegistPower.vue?vue&type=script&lang=js&"
import style0 from "./RegistPower.vue?vue&type=style&index=0&id=2d5d53ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d53ae",
  null
  
)

export default component.exports